/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Belt { 
    length?: number;
    color?: string;
    thickness?: Belt.ThicknessEnum;
    edge?: Belt.EdgeEnum;
    shape?: Belt.ShapeEnum;
    width?: number;
    labelPlate?: string;
    paintedLabel?: string;
    cottonLayer?: number;
    protective?: boolean;
    reflectiveStripe?: boolean;
    minimalLength?: number;
    maximalLength?: number;
    punchingScrewSize?: string;
    punchingSpace?: number;
    quickRelease?: boolean;
    solar?: boolean;
    elasticBeltType?: Belt.ElasticBeltTypeEnum;
    growingBeltType?: Belt.GrowingBeltTypeEnum;
}
export namespace Belt {
    export const ThicknessEnum = {
        StSt: 'ST_ST',
        SfSf: 'SF_SF',
        StSf: 'ST_SF',
        SolarBelt: 'SOLAR_BELT',
        StStStSt: 'ST_ST_ST_ST',
        ElasticBand: 'ELASTIC_BAND'
    } as const;
    export type ThicknessEnum = typeof ThicknessEnum[keyof typeof ThicknessEnum];
    export const EdgeEnum = {
        Rounded: 'rounded',
        Smooth: 'smooth'
    } as const;
    export type EdgeEnum = typeof EdgeEnum[keyof typeof EdgeEnum];
    export const ShapeEnum = {
        Oval: 'oval',
        Round: 'round',
        OvalRound: 'oval-round',
        DropShaped: 'drop-shaped'
    } as const;
    export type ShapeEnum = typeof ShapeEnum[keyof typeof ShapeEnum];
    export const ElasticBeltTypeEnum = {
        Type1: 'type 1',
        Type2: 'type 2',
        ElasticMooseCollar: 'elastic moose collar'
    } as const;
    export type ElasticBeltTypeEnum = typeof ElasticBeltTypeEnum[keyof typeof ElasticBeltTypeEnum];
    export const GrowingBeltTypeEnum = {
        G1: 'G-1'
    } as const;
    export type GrowingBeltTypeEnum = typeof GrowingBeltTypeEnum[keyof typeof GrowingBeltTypeEnum];
}


export type ThicknessEnum = typeof Belt.ThicknessEnum[keyof typeof Belt.ThicknessEnum];
export type EdgeEnum = typeof Belt.EdgeEnum[keyof typeof Belt.EdgeEnum];
export type ShapeEnum = typeof Belt.ShapeEnum[keyof typeof Belt.ShapeEnum];
export type ElasticBeltTypeEnum = typeof Belt.ElasticBeltTypeEnum[keyof typeof Belt.ElasticBeltTypeEnum];
export type GrowingBeltTypeEnum = typeof Belt.GrowingBeltTypeEnum[keyof typeof Belt.GrowingBeltTypeEnum];
